export const endpoints = {
    getProfile: '/verification/self/verify',
    getTestResult: '/user/getTestResult',
    setConsent: '/user/consent',
    updateUserProfile: '/user/update',
    verificationProgress: '/verification/self/progress',
    requestPhoneLink: '/verification/self/request/phone',
    requestEmailLink: '/verification/self/request/email',

    initiateTwoFaSession: '/verification/self/initiate/twoFa/session',
    updateUserContact: '/verification/self/update/user-pii/twoFa',
    sendTwoFaOTP: '/verification/self/send/twoFa/otp',
    verifyTwoFaOTP: '/verification/self/verify/twoFa/otp',

    runRiskScore: '/identity/risk/match',
    runQuickVerify: '/identity/quick-verify',

    runAuthDB: '/identity/verify',

    getKbaQuestions: '/identity/kba',
    verifyKbaAnswers: '/identity/kba-verification',

    bankConnectUrl: '/identity/bank/connect/url',
    bankAccountResult: '/identity/bank/account/result',

    reauthenticateStatus: '/reauthenticate/session/status',
    reauthenticateSelfie: '/reauthenticate/session/selfie',
    reauthenticateProgress: '/reauthenticate/session/progress',
    reauthenticateDeviceInfo: '/reauthenticate/session/information',
    reauthenticateCode: '/reauthenticate/session/code',
    reauthenticateRequestPhone: '/reauthenticate/session/request/phone',
    reauthenticateRequestEmail: '/reauthenticate/session/request/email',
    reauthenticateLiveness: '/reauthenticate/session/liveness-check',
    reauthenticateLivenessSession: '/reauthenticate/session/v2/liveness/session',
    reauthenticateSelfieVerify: '/reauthenticate/session/v2/selfie/verify',

    educationDegreeNames: '/education/degree/names',
    educationSchoolNames: '/education/school/names',
    educationVerify: '/education/v2/verify',

    employmentVerify: '/employment/v2/verify',

    professionalLicenseNames: '/identity/professional/license/names',
    professionalLicenseVerify: '/identity/professional/license',

    //govtId (features/govtId/api.js)
    chargeDocument: '/verification/self/document/charge',
    documentFrontOcr: '/verification/self/document/front/ocr',
    verifySelfie: '/verification/self/selfie/verify',
    saveDocumentResult: '/verification/self/document/result',
    saveLiveness: '/verification/self/liveness',
    saveLivenessResult: '/verification/self/liveness/result',
    resultComplete: '/verification/self/result/complete',

    //govtId v2 (features/govtId/v2/api.js) — `documentFrontOcr` above is the one endpoint
    //the v2 flow also calls; nothing else above is shared
    govtIdV2DocumentProcess: '/verification/self/v2/document/process',
    govtIdV2DocumentResult: '/verification/self/v2/document/result',
    govtIdV2LivenessSession: '/verification/self/v2/liveness/session',
    govtIdV2SelfieVerify: '/verification/self/v2/selfie/verify',
    govtIdV2DocumentLogs: '/verification/self/v2/document/logs',
};
